let util = {};
util.title = function (title) {
	title = title || 'first App';
	window.document.title = title;
};

util.inOf = function (arr, targetArr) {
	let res = true;
	arr.forEach(item => {
		if (targetArr.indexOf(item) < 0) {
			res = false;
		}
	});
	return res;
};

util.oneOf = function (ele, targetArr) {
	if (targetArr.indexOf(ele) >= 0) {
		return true;
	} else {
		return false;
	}
};

util.showThisRoute = function (itAccess, currentAccess) {
	if (typeof itAccess === 'object' && Array.isArray(itAccess)) {
		return util.oneOf(currentAccess, itAccess);
	} else {
		return itAccess === currentAccess;
	}
};

util.getRouterObjByName = function (routers, name) {
	if (!name || !routers || !routers.length) {
		return null;
	}
	// debugger;
	let routerObj = null;
	for (let item of routers) {
		if (item.name === name) {
			return item;
		}
		routerObj = util.getRouterObjByName(item.children, name);
		if (routerObj) {
			return routerObj;
		}
	}
	return null;
};

util.handleTitle = function (vm, item) {
	if (typeof item.title === 'object') {
		return vm.$t(item.title.i18n);
	} else {
		return item.title;
	}
};

util.openNewPage = function (vm, name, argu, query) {
	let pageOpenedList = vm.$store.state.app.pageOpenedList;
	let openedPageLen = pageOpenedList.length;
	let i = 0;
	let tagHasOpened = false;
	while (i < openedPageLen) {
		if (name === pageOpenedList[i].name) { // 页面已经打开
			vm.$store.commit('pageOpenedList', {
				index: i,
				argu: argu,
				query: query
			});
			tagHasOpened = true;
			break;
		}
		i++;
	}
	if (!tagHasOpened) {
		let tag = vm.$store.state.app.tagsList.filter((item) => {
			if (item.children) {
				return name === item.children[0].name;
			} else {
				return name === item.name;
			}
		});
		tag = tag[0];
		if (tag) {
			tag = tag.children ? tag.children[0] : tag;
			if (argu) {
				tag.argu = argu;
			}
			if (query) {
				tag.query = query;
			}
			vm.$store.commit('increateTag', tag);
		}
	}
	vm.$store.commit('setCurrentPageName', name);
};

util.toDefaultPage = function (routers, name, route, next) {
	let len = routers.length;
	let i = 0;
	let notHandle = true;
	while (i < len) {
		if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
			route.replace({
				name: routers[i].children[0].name
			});
			notHandle = false;
			next();
			break;
		}
		i++;
	}
	// console.log('notHandle=' + notHandle);
	if (notHandle) {
		next();
	}
};

util.fullscreenEvent = function (vm) {
	vm.$store.commit('initCachepage');
	// 权限菜单过滤相关
	vm.$store.commit('updateMenulist');
	// 全屏相关
};

util.isEmpty = function (value) {
	if (value === undefined || value === null || value === 'null' || value === '' || value.length <= 0) {
		return true;
	} else {
		return false;
	}
};
let path = {};
util.setCurrentPath = function (appname) {
	let currentPath = window.location.href;
	path[appname] = currentPath;
	// console.log('path>>>' + JSON.stringify(path));
};
util.getCurrentPath = function (appname) {
	let currentPath = path[appname];
	console.log(appname + 'currentPath>>>' + currentPath);
	return currentPath;
};

function formatTimeNumber(n) {
	n = n.toString();
	return n[1] ? n : '0' + n;
}

// 格式化日期，返回yyyy-mm-dd
util.formatDate = function (time) {
	if (time) {
		if (time.length === 10) time = time * 1000;
		let tmpDate = new Date(parseInt(time));
		let year = tmpDate.getFullYear();
		let month = tmpDate.getMonth() + 1;
		let day = tmpDate.getDate();
		return year + '-' + formatTimeNumber(month) + '-' + formatTimeNumber(day);
	}
	return '';
};
// 格式化日期，返回yyyy-mm-dd hh:mm:ss
util.formatDateTime = function (time) {
	if (time) {
		if (time.length === 10) time = time * 1000;
		let tmpDate = new Date(parseInt(time));
		let year = tmpDate.getFullYear();
		let month = tmpDate.getMonth() + 1;
		let day = tmpDate.getDate();
		let hour = tmpDate.getHours();
		let min = tmpDate.getMinutes();
		let sec = tmpDate.getSeconds();
		return year + '-' + formatTimeNumber(month) + '-' + formatTimeNumber(day) + ' ' + formatTimeNumber(hour) + ':' + formatTimeNumber(min) + ':' + formatTimeNumber(sec);
	}
	return '';
};
// 格式化日期，返回hh:mm:ss
util.formatTime = function (time) {
	if (time) {
		if (time.length === 10) time = time * 1000;
		let tmpDate = new Date(parseInt(time));
		let hour = tmpDate.getHours();
		let min = tmpDate.getMinutes();
		let sec = tmpDate.getSeconds();
		return formatTimeNumber(hour) + ':' + formatTimeNumber(min);
	}
	return '';
};
// 回车搜索
util.quickSearch = function (formName, fn) {
	let inputs = document.querySelector('.' + formName).querySelectorAll("input[type='text']");
	inputs.forEach(item => {
		item.onkeypress = function (v) {
			if (v.charCode === 13) {
				fn();
			}
		};
	});
}
// 大图预览
util.showBigPic = function (url) {
	let shadow = document.createElement('div');
	shadow.className = 'bp-shadow';
	shadow.onclick = function () {
		if (this) {
			document.body.removeChild(this);
		}
	}
	// 优化点击遮罩层并拖拽导致的图片蓝色背景问题
	shadow.onmousedown = function () {
		document.onmousemove = function () {
			return false;
		}
	}
	let wrap = document.createElement('div');
	wrap.className = 'bp-wrap';
	let img = document.createElement('img');
	img.src = url;
	document.body.appendChild(shadow);
	wrap.appendChild(img);
	shadow.appendChild(wrap);
}
// 切换loading的背景图标的显示隐藏
util.toggleEmptyBlock = function (state) {
	setTimeout(() => {
		let empty_block = document.getElementsByClassName('el-table__empty-block')[0];
		if (empty_block) {
			if (state === 'hidden') {
				empty_block.classList.remove('empty-data');
			} else if (state === 'visible') {
				empty_block.classList.add('empty-data');
			}
		}
		let empty_list = document.getElementsByClassName('no-data')[0];
		if (empty_list) {
			if (state === 'hidden') {
				empty_list.classList.remove('empty');
			} else if (state === 'visible') {
				empty_list.classList.add('empty');
			}
		}
	}, 100);
}
// 图片宽高显示
util.initImg = function () {
	setTimeout(() => {

		console.log('遍历图片=========');
		let imgList = document.querySelectorAll('img');
		// console.log(imgList);
		// console.log(imgList.length);

		for (let img of imgList) {
			// console.log('img=====', img);
			// console.log('src=====', img.src);
			if (img && img.src) {
				let cur = new Image();
				cur.src = img.src;
				cur.onload = function () {
					console.log('width:' + img.width + ',height:' + img.height);

					if (img.width >= img.height) {
						img.style.width = '100%';
						img.style.height = 'auto';
					}
					if (img.width < img.height) {
						img.style.height = '100%';
						img.style.width = 'auto';
					}

				}
			}

		}

	}, 0)
}
/**
 * 返回mm
 */
/**
 *  返回正确的姓名表达式
 */
util.trueName = function (rule, value, callback) {
	console.log(2222222222222, rule, value, callback);
	let reg = /(^[\u4e00-\u9fa5]{1}[\u4e00-\u9fa5\.·。]{0,49}[\u4e00-\u9fa5]{1}$)|(^[a-zA-Z]{1}[a-zA-Z\s \.]{0,49}[a-zA-Z]{1}$)/;
	if (value) {
		let len = value.length;
		let len2 = value.replace(/\s+/g, '').length;
		let c = (len - len2) < 2;
		if (c) {
			console.log(!reg.test(value), '!reg.test(value)');
			if (!reg.test(value)) {
				callback(new Error('姓名格式错误')); // 不能输入(像!@#$%^&*以及空格等
			} else {
				callback();
			}
		} else {
			callback(new Error('姓名格式错误'));
		}
	} else {
		callback();
	}

}
//根据当前时间判断历史视频结束时间
util.setEndTime = function (time) {
	let newDate = new Date().getTime();
	if (new Date(time).getTime() > newDate) {
		newDate = this.formatDateTime(newDate);
		return newDate;
	} else {
		return time;
	}
}
export default util;



// WEBPACK FOOTER //
// ./main/utils/util.js